import { ApiService } from '@sparklayer-io/spark-dash-core/types/api';
import type { QuoteStatusAction } from '../constants';
import { toApiPayload } from './payload';
import { QuoteStatusApi, type QuoteStatusApiContract } from './quote-status.api';

export type QuoteStatus = {
  id: string;
  name: string;
  slug: string;
  default: boolean;
  next: string | null;
  actions: QuoteStatusAction[];
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};

/**
 * The writable shape of a quote status. The API itself owns `id` and the timestamps, and a `next`
 * of `''` means "no change in status" which the service maps to `null`.
 */
export type QuoteStatusPayload = {
  name: string;
  slug: string;
  default: boolean;
  next: string;
  actions: QuoteStatusAction[];
};

export interface QuoteStatusesApiContract {
  list(): Promise<QuoteStatus[]>;
  create(payload: QuoteStatusPayload): Promise<void>;
  status(id: string): QuoteStatusApiContract;
}

declare module '@sparklayer-io/spark-dash-core/context/page-context' {
  interface Apis {
    quoteStatuses: QuoteStatusesApiContract;
  }
}

export class QuoteStatusesApi extends ApiService implements QuoteStatusesApiContract {
  public list(): Promise<QuoteStatus[]> {
    return this.api.proxy<QuoteStatus[]>({
      method: 'GET',
      path: '/v1/quote-statuses',
    });
  }

  public create(payload: QuoteStatusPayload): Promise<void> {
    return this.api.proxy<void>({
      method: 'POST',
      path: '/v1/quote-statuses',
      payload: toApiPayload(payload),
    });
  }

  public status(id: string): QuoteStatusApiContract {
    return new QuoteStatusApi(this.api, id);
  }
}
